import styled, { css } from 'styled-components'
import { color, size } from 'ui/themes/utils'

export const ModalGallery = styled.div`
  height: 100%;
  padding: ${size('padding', 'md')} !important;
  background-color: ${color('white')};
`

export const Title = styled.h3`
  text-align: center;

  padding: ${size('padding', 'sm')} 0;

  font-weight: 500 !important;
  line-height: 25px;

  width: 100%;
  margin: 0 auto;

  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`

export const ControlWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: ${color('white')};
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: ${color('Background/Secondary')};
    transform: scale(1.05);
  }

  svg {
    width: 16px;
    height: 16px;
    color: ${color('Text/Primary')};
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  height: 20px;
  margin-bottom: ${size('margin', 'md')} !important;
  z-index: 1;
`

export const Body = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  flex: 1;
  overflow: hidden;

  padding: ${size('padding', 'sm')};

  position: relative;
`

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;

  margin-top: ${size('margin', 'md')} !important;
`

export const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  position: absolute;
  top: 50%;
  left: 0;

  width: 100%;

  transform: translateY(-50%);
`

export const GalleryImages = styled.div`
  position: absolute;

  left: ${({ offset }) => offset || 0};
  top: 0;

  display: flex;
  justify-content: center;
  align-items: center;

  transition: left 0.3s ease-in-out;
`

export const GalleryImagesContainer = styled.div`
  position: relative;
  overflow: hidden;
`

export const Image = styled.img`
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
`

export const GalleryImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-left: ${size('margin', 'xs')} !important;

  overflow: hidden;

  border: 2px solid transparent !important;
  border-radius: 8px;

  &:hover {
    border-color: ${({ brandingColor }) => brandingColor};
    cursor: pointer;
  }

  ${({ selected }) =>
    selected &&
    css`
      border-color: ${({ brandingColor }) => brandingColor} !important;
    `}
`

export const Gallery = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  ${({ size, offset }) => css`
    ${GalleryImagesContainer} {
      /* 5 = gap between images */
      width: ${(size + 5) * 3 + 5}px;
      height: ${size}px;
    }

    ${GalleryImageContainer} {
      height: ${size}px;
      width: ${size}px;

      img {
        padding: 10px;
      }
    }

    ${GalleryImages} {
      left: -${offset * (size * 0.85)}px;
    }
  `}
`
